import React, {FC} from 'react';
import {CChart} from "@coreui/react-chartjs";
import {getStyle} from "@coreui/utils";
import {colors} from "../../../../colorsForCharts/colorsForCharts";

interface IChartsProps {
  labels: string[];
  data: any[];
}

const RadarChart: FC<IChartsProps> = ({labels, data}) => {

  return (
    <>
      <CChart
        type="radar"
        data={{
          labels: labels,
          datasets: data?.map((el: any, index: number) => {
            return {
              label: el.label,
              backgroundColor: colors[index],
              borderColor: colors[index],
              pointBackgroundColor: colors[index],
              pointBorderColor: "#fff",
              pointHoverBackgroundColor: '#fff',
              pointHoverBorderColor: 'rgba(220, 220, 220, 1)',
              data: el.data || [],
              fill: true
            }
          })
        }}
        options={{
          plugins: {
            legend: {
              labels: {
                color: getStyle('--cui-body-color'),
              },
            },
          },
          scales: {
            r: {
              grid: {
                color: getStyle('--cui-border-color-translucent'),
              },
              ticks: {
                color: getStyle('--cui-body-color'),
              },
              angleLines: {
                color: getStyle('--cui-border-color-translucent'),
              },
              pointLabels: {
                color: getStyle('--cui-body-color'),
              },
              beginAtZero: true,
            },
          },
        }}
      />
    </>
  );
};

export default RadarChart;
